import cryptoJS from "crypto-js"
import Keys from "../../../utils/Admin/constants/keys.constants";


/** set data to session storage */
const setToStorage = (payload) => {
    /** 
     * payload is an object contains sessiob storage 
     * update keys and values 
     */
    const entries = Object.entries(payload)
    entries.forEach(value => {
        if (value[0] !== 'accessToken') {
            let encryptedValue = cryptoJS.AES.encrypt(value[1].toString(), Keys.CIPHER_KEY).toString()
            sessionStorage.setItem(value[0],encryptedValue)
        } else {
            sessionStorage.setItem(value[0],value[1])
        }
    })
}

/** get data from session storage */
const getFromStorage = (keys) => {
    /** 
     * keys are array of strings[key of session storage value]
     * Key string will get the value of the passed key
     * Ex: ['user_id','email']
     */
    let storageObj = {}
    if (keys.length) {
        keys.forEach(key => {
            if (sessionStorage?.getItem(key) !== null) {
                if (key !== 'accessToken') { 
                    let byteString = cryptoJS.AES.decrypt(sessionStorage?.getItem(key), Keys.CIPHER_KEY)
                    let decryptedValue = byteString.toString(cryptoJS.enc.Utf8)
                    storageObj = { ...storageObj, [key]: decryptedValue };
                } else {
                    storageObj = { ...storageObj, [key]: sessionStorage?.getItem(key) };
                }
            }
        })
    }
    return {...storageObj}
}

export {setToStorage, getFromStorage}